module.exports = __webpack_public_path__ + "static/media/drop-down-icon.2c1d15ee.svg";